export default [
  {
    path: '/homework',
    name: '作业详情',
    component: () => import(/* webpackChunkName: "homework" */ '../views/HomeWork/index.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/homework/reviewDetail',
    name: '',
    component: () => import(/* webpackChunkName: "reviewDetail" */ '../views/HomeWork/reviewDetail/reviewDetail.vue')
  },
  {
    path: '/homework/call',
    name: '催交',
    component: () => import(/* webpackChunkName: "call" */ '../views/HomeWork/call/call.vue')
  },
  {
    path: '/homework/repulse',
    name: '打回',
    component: () => import(/* webpackChunkName: "repulse" */ '../views/HomeWork/repulse/repulse.vue')
  },
  {
    path: '/homework/stuWorkSubmit',
    name: '提交作业',
    component: () => import(/* webpackChunkName: "stuWorkSubmit" */ '../views/HomeWork/stuWorkSubmit/stuWorkSubmit.vue')
  },
  {
    path: '/homework/stuWorkShareList',
    name: '已分享作业',
    component: () => import(/* webpackChunkName: "stuWorkShareList" */ '../views/HomeWork/stuWorkShareList/stuWorkShareList.vue')
  },
  {
    path: '/homework/stuUserList',
    name: '所在小组',
    component: () => import(/* webpackChunkName: "stuUserList" */ '../views/HomeWork/stuUserList/stuUserList.vue')
  },
  {
    path: '/homework/rechecking',
    name: '作业查重信息',
    component: () => import(/* webpackChunkName: "rechecking" */ '../views/HomeWork/rechecking/rechecking.vue')
  },
  {
    path: '/homework/repeat',
    name: '重复部分以红色标出',
    component: () => import(/* webpackChunkName: "rechecking" */ '../views/HomeWork/homeworkRepeat/index.vue')
  },
  {
    path: '/homework/recheckRules',
    name: '查重规则',
    component: () => import(/* webpackChunkName: "recheckRules" */ '../views/HomeWork/recheckRules/recheckRules.vue')
  },
  {
    path: '/homework/stuWorkDetail',
    name: '',
    component: () => import(/* webpackChunkName: "stuWorkDetail" */ '../views/HomeWork/stuWorkDetail/stuWorkDetail.vue')
  },
  {
    path: '/homework/stuWorkHistory',
    name: '作业提交历史',
    component: () => import(/* webpackChunkName: "stuWorkHistory" */ '../views/HomeWork/stuWorkHistory/stuWorkHistory.vue')
  },
  {
    path: '/WechatDownload',
    name: '下载',
    component: () => import(/* webpackChunkName: "WechatDownload" */ '../components/Common/WechatDownload/WechatDownload.vue')
  },
  {
    path: '/homework/filter',
    name: '筛选',
    component: () => import(/* webpackChunkName: "filter" */ '../views/HomeWork/filter/filter.vue')
  },
  {
    path: '/homework/discussDetail',
    name: '评论详情',
    component: () => import(/* webpackChunkName: "discussDetail" */ '../views/HomeWork/discussDetail/discussDetail.vue')
  },

]
